module.exports = __webpack_public_path__ + "img/Grafana.ea6213b3.png";